
import {HttpRequest,HttpMethod} from "./http";

class PlatformProvider extends HttpRequest {

	ConnectPlatform(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params}/connect` );
	}

	SyncProduct(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params.platform}/products/sync?shop_id=${params.shop_id}`, params);
	}

	SyncOrder(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params.platform}/orders/sync?shop_id=${params.shop_id}&shop_name=${params.shop_name}&sync_date=${params.sync_date}&sync_day=${params.sync_day}`, params);
	}

	SyncProductV2(params) {
		return this.request(HttpMethod.Post,`/api/platform/v2/${params.platform}/products/sync?shop_id=${params.shop_id}&shop_cipher=${params.shop_cipher}&shop_name=${params.shop_name}`, params);
	}

	SyncOrderV2(params) {
		return this.request(HttpMethod.Post,`/api/platform/v2/${params.platform}/orders/sync?shop_id=${params.shop_id}&shop_name=${params.shop_name}&shop_cipher=${params.shop_cipher}&time_from=${params.time_from}&time_to=${params.time_to}`, params);
	}

	ListSeller(params) {
		return this.request(HttpMethod.Get,`/api/platform/seller` );
	}

	RefreshToken(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params.platform}/refreshtoken?shop_id=${params.shop_id}` );
	}
}

export default PlatformProvider